import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import { Cart } from '@js/api/types/cart/Cart'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { cartFragment } from '@js/api/fragments/cartFragment'

interface GetAuthUserCartResponse {
  data: {
    customerCart: Cart
  }
  errors?: [{ message: string }]
}

export const authUserCartQuery = gql`
  query {
    customerCart {
      ...CartDetails
    }
  }
  ${cartFragment}
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const getAuthUserCart = async (): Promise<Cart | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<GetAuthUserCartResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: authUserCartQuery,
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.customerCart) {
    return data.data.customerCart
  }

  return null
}
